var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-outer" }, [
    _c("div", { staticClass: "login-inner" }, [
      _c("h4", [_vm._v(_vm._s(_vm.$t("login.TITLE")))]),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c("label", { attrs: { for: "name" } }, [
            _vm._v(_vm._s(_vm.$t("login.FIELD_NAME"))),
          ]),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.name,
                  expression: "name",
                },
              ],
              staticClass: "input-text",
              attrs: {
                id: "name",
                type: "text",
                required: "",
                autofocus: "",
                autoCorrect: "off",
                autoCapitalize: "none",
              },
              domProps: { value: _vm.name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.name = $event.target.value
                },
              },
            }),
          ]),
          _c("div", [
            _c("label", { attrs: { for: "password" } }, [
              _vm._v(_vm._s(_vm.$t("login.FIELD_PWD"))),
            ]),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.password,
                    expression: "password",
                  },
                ],
                staticClass: "input-text",
                attrs: {
                  id: "password",
                  type: "password",
                  required: "",
                  autoCorrect: "off",
                  autoCapitalize: "none",
                },
                domProps: { value: _vm.password },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.password = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _c("div", [
            _c(
              "button",
              { staticClass: "login-button", attrs: { type: "submit" } },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("login.BUTTON_LOGIN")) +
                    "\n        "
                ),
              ]
            ),
            _c("div", { staticClass: "reset-reminder" }, [
              _c("em", [_vm._v(_vm._s(_vm.$t("login.RESET_REMINDER")))]),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "reset-button",
                    attrs: { type: "button" },
                    on: { click: _vm.resetPassword },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("login.BUTTON_RESET")) +
                        "\n            "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm.errorMsg
            ? _c("div", [
                _vm._v("\n        " + _vm._s(_vm.errorMsg) + "\n      "),
              ])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }